import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAuth({ children }) {
    const { me, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="w-full flex flex-col items-center justify-center py-32 gap-4 text-white/70">
                <div className="h-10 w-10 border-4 border-white/20 border-t-white rounded-full animate-spin" />
                <div className="text-lg tracking-wide">Načítám…</div>
            </div>
        );
    }

    if (!me) {
        return <Navigate to="/access-denied" replace state={{ from: location }} />;
    }

    return children;
}
